module.exports = __webpack_public_path__ + "50b2bcc64bc66fbe1b3a0ab83923265a.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-index-img5.jpg
// module id = 230
// module chunks = 3